import { c as _c } from "react/compiler-runtime";
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { css } from '@repo/pandacss/css';
import type { SegmentActionNamePrefixType } from '../../../model/types';
import { ListIconFilled } from '../../Icons';
import { Accordion } from '../Accordion';
import { RewardsRateRow } from './RewardsRateRow';
export const RewardsBreakdown = t0 => {
  const $ = _c(15);
  const {
    actionSection,
    creditCardOffer,
    segmentActionNamePrefix,
    expandedByDefault
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    rewardsRates,
    rewardRateDetails: t2
  } = t1;
  const {
    type: rewardRateType
  } = t2;
  if (rewardsRates.length === 0) {
    return null;
  }
  const t3 = `${segmentActionNamePrefix}_rewards_breakdown`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ListIconFilled />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = css({
      display: "grid",
      gridTemplateColumns: "[auto 1fr]",
      gap: "2"
    });
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== rewardRateType || $[3] !== rewardsRates) {
    let t7;
    if ($[5] !== rewardRateType) {
      t7 = (rewardsRate, i) => <RewardsRateRow key={i} description={rewardsRate.description} index={i} rate={rewardsRate.rate} type={rewardRateType || ""} />;
      $[5] = rewardRateType;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    t6 = rewardsRates.map(t7);
    $[2] = rewardRateType;
    $[3] = rewardsRates;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <div className={t5} data-testid="rewardsBreakdownInnerContent">{t6}</div>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== actionSection || $[11] !== expandedByDefault || $[12] !== t3 || $[13] !== t7) {
    t8 = <Accordion analyticsActionName={t3} actionSection={actionSection} analyticsKey="rewards-breakdown" iconComponent={t4} title="Rewards breakdown" expandedByDefault={expandedByDefault}>{t7}</Accordion>;
    $[10] = actionSection;
    $[11] = expandedByDefault;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};